export const cashierMenus = {
    Store: [
        {
            action: 'zmdi-shopping-cart',
            title: 'message.shoppingList',
            // active: false,
            label: 'Old',
            path: '/shopping-list',
            exact: true
        },
    ]
}